// extracted by mini-css-extract-plugin
export var button = "_cz-4";
export var hasDarkBackground = "_cz-7";
export var hasLightBackground = "_cz-6";
export var iconWrapper = "_cz-0";
export var large = "_cz-2";
export var medium = "_cz-1";
export var small = "_cz-5";
export var xsmall = "_cz-3";